import { Suspense } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { contactsApi } from '@/api/queries/contacts';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { ContactForm } from './-components/detail/ContactForm';

export const Route = createFileRoute('/contacts/$id')({
  component: () => (
    <Suspense fallback={<LoadingSpinner message="Loading contact..." />}>
      <ContactFormLoader />
    </Suspense>
  ),
});

// eslint-disable-next-line react-refresh/only-export-components
function ContactFormLoader() {
  const { id } = Route.useParams();
  const { data: contact } = contactsApi.useDetail(id);
  const name = [contact?.profile?.firstName, contact?.profile?.lastName].filter(Boolean).join(' ');
  useSetBreadcrumbs([
    { label: 'Contacts', to: '/contacts' },
    { label: name || 'Contact' },
  ]);
  return <ContactForm contactData={contact} />;
}
